import * as React from 'react';
import { FormFieldsBox } from '../wrappers';
import { Divider, useTheme } from '@material-ui/core';
import BasicTypography from 'app/components/Typography/BasicTypography';
import { BookitTypographyVariant } from '@material-ui/core/styles/createTypography';

export interface FormFieldsSectionProps {
  children: React.ReactNode;
  titleSection?: string | React.ReactNode;
  titleLink?: React.ReactNode;
  styleSection?: React.CSSProperties;
  withTopSeparator?: boolean;
  withBottomSeparator?: boolean;
  titleVariant?: BookitTypographyVariant;
}
export const FormFieldsSection = (props: FormFieldsSectionProps) => {
  const {
    children,
    titleSection,
    titleLink,
    styleSection,
    withTopSeparator,
    withBottomSeparator,
    titleVariant,
  } = props;
  const theme = useTheme();
  return (
    <FormFieldsBox
      style={styleSection}
      theme={theme}
      className={'fields-section'}
    >
      {withTopSeparator && (
        <Divider
          style={{ width: '100%', alignSelf: 'center', marginBottom: 12 }}
        />
      )}
      {titleSection && (
        <div className={'sectiontitle'}>
          <BasicTypography variant={titleVariant ?? 'boldM'}>
            {titleSection}
          </BasicTypography>
          {titleLink || <></>}
        </div>
      )}

      <div className={`fields`}>{children}</div>
      {withBottomSeparator && (
        <Divider
          style={{ width: '100%', alignSelf: 'center', marginTop: 12 }}
        />
      )}
    </FormFieldsBox>
  );
};
